// All 30 official G2 badges earned by Uniskai — Spring 2026.
// Badge SVGs live in /public/logos/g2/. Source file names preserved as filename here.

export type G2Category = "CMP" | "CCM";
export type G2Segment =
  | "Overall"
  | "Small-Business"
  | "Mid-Market"
  | "EMEA"
  | "MEA"
  | "Small-Business EMEA"
  | "Mid-Market EMEA";

export type G2Badge = {
  category: G2Category;
  badgeType: string;
  segment: G2Segment;
  filename: string;
};

export const g2Badges: G2Badge[] = [
  // Cloud Management Platforms (CMP) — 12
  {
    category: "CMP",
    badgeType: "Best Results",
    segment: "Overall",
    filename: "CloudManagementPlatforms_BestResults_Total.svg",
  },
  {
    category: "CMP",
    badgeType: "Best Estimated ROI",
    segment: "Overall",
    filename: "CloudManagementPlatforms_BestEstimatedROI_Roi.svg",
  },
  {
    category: "CMP",
    badgeType: "Best Meets Requirements",
    segment: "Overall",
    filename: "CloudManagementPlatforms_BestMeetsRequirements_MeetsRequirements.svg",
  },
  {
    category: "CMP",
    badgeType: "Best Support",
    segment: "Overall",
    filename: "CloudManagementPlatforms_BestSupport_QualityOfSupport.svg",
  },
  {
    category: "CMP",
    badgeType: "Easiest Admin",
    segment: "Overall",
    filename: "CloudManagementPlatforms_EasiestAdmin_EaseOfAdmin.svg",
  },
  {
    category: "CMP",
    badgeType: "Easiest to Do Business With",
    segment: "Overall",
    filename: "CloudManagementPlatforms_EasiestToDoBusinessWith_EaseOfDoingBusinessWith.svg",
  },
  {
    category: "CMP",
    badgeType: "Easiest to Use",
    segment: "Overall",
    filename: "CloudManagementPlatforms_EasiestToUse_EaseOfUse.svg",
  },
  {
    category: "CMP",
    badgeType: "Fastest Implementation",
    segment: "Overall",
    filename: "CloudManagementPlatforms_FastestImplementation_GoLiveTime.svg",
  },
  {
    category: "CMP",
    badgeType: "High Performer",
    segment: "Overall",
    filename: "CloudManagementPlatforms_HighPerformer_HighPerformer.svg",
  },
  {
    category: "CMP",
    badgeType: "High Performer",
    segment: "EMEA",
    filename: "CloudManagementPlatforms_HighPerformer_EMEA_HighPerformer.svg",
  },
  {
    category: "CMP",
    badgeType: "Highest User Adoption",
    segment: "Overall",
    filename: "CloudManagementPlatforms_HighestUserAdoption_Adoption.svg",
  },
  {
    category: "CMP",
    badgeType: "Users Most Likely to Recommend",
    segment: "Overall",
    filename: "CloudManagementPlatforms_UsersMostLikelyToRecommend_Nps.svg",
  },

  // Cloud Cost Management (CCM) — 18
  {
    category: "CCM",
    badgeType: "Best Estimated ROI",
    segment: "Overall",
    filename: "CloudCostManagement_BestEstimatedROI_Roi.svg",
  },
  {
    category: "CCM",
    badgeType: "Best Estimated ROI",
    segment: "Small-Business",
    filename: "CloudCostManagement_BestEstimatedROI_Small-Business_Roi.svg",
  },
  {
    category: "CCM",
    badgeType: "Best Support",
    segment: "Overall",
    filename: "CloudCostManagement_BestSupport_QualityOfSupport.svg",
  },
  {
    category: "CCM",
    badgeType: "Best Support",
    segment: "Small-Business",
    filename: "CloudCostManagement_BestSupport_Small-Business_QualityOfSupport.svg",
  },
  {
    category: "CCM",
    badgeType: "Easiest Admin",
    segment: "Overall",
    filename: "CloudCostManagement_EasiestAdmin_EaseOfAdmin.svg",
  },
  {
    category: "CCM",
    badgeType: "Easiest Admin",
    segment: "Small-Business",
    filename: "CloudCostManagement_EasiestAdmin_Small-Business_EaseOfAdmin.svg",
  },
  {
    category: "CCM",
    badgeType: "Easiest to Do Business With",
    segment: "Overall",
    filename: "CloudCostManagement_EasiestToDoBusinessWith_EaseOfDoingBusinessWith.svg",
  },
  {
    category: "CCM",
    badgeType: "Easiest to Do Business With",
    segment: "Small-Business",
    filename: "CloudCostManagement_EasiestToDoBusinessWith_Small-Business_EaseOfDoingBusinessWith.svg",
  },
  {
    category: "CCM",
    badgeType: "Fastest Implementation",
    segment: "Overall",
    filename: "CloudCostManagement_FastestImplementation_GoLiveTime.svg",
  },
  {
    category: "CCM",
    badgeType: "Fastest Implementation",
    segment: "Small-Business",
    filename: "CloudCostManagement_FastestImplementation_Small-Business_GoLiveTime.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "Overall",
    filename: "CloudCostManagement_HighPerformer_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "EMEA",
    filename: "CloudCostManagement_HighPerformer_EMEA_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "MEA",
    filename: "CloudCostManagement_HighPerformer_MEA_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "Mid-Market",
    filename: "CloudCostManagement_HighPerformer_Mid-Market_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "Mid-Market EMEA",
    filename: "CloudCostManagement_HighPerformer_Mid-Market_EMEA_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "Small-Business",
    filename: "CloudCostManagement_HighPerformer_Small-Business_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "High Performer",
    segment: "Small-Business EMEA",
    filename: "CloudCostManagement_HighPerformer_Small-Business_EMEA_HighPerformer.svg",
  },
  {
    category: "CCM",
    badgeType: "Most Implementable",
    segment: "Small-Business",
    filename: "CloudCostManagement_MostImplementable_Small-Business_Total.svg",
  },
];

export const g2BadgeCount = g2Badges.length;
